import React from 'react';
import { MdOutlineArrowForwardIos } from 'react-icons/md';
import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';
import {
    dispatchTrackingEvent,
    HOMEPAGE_SPECIAL_OFFER_BANNER,
    HOME_PAGE_VIEW_SPECIAL_OFFER_BANNER,
} from '@PROJECT_ROOT/assets/responsive-frontend/js/services/tracking';
import useIsMobileView, { getIsMobileFromUserAgent } from '@PROJECT_ROOT/assets/responsive-frontend/js/custom-hooks/useIsMobileView';
import useIsMounted from '@PROJECT_ROOT/assets/responsive-frontend/js/custom-hooks/useIsMounted';
import useIntersectionRef from '@PROJECT_ROOT/assets/responsive-frontend/js/custom-hooks/useIntersectionRef';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

export default function AttractiveOffersBanners({ data, ssrUserAgent }) {
    const isMobile = useIsMobileView(getIsMobileFromUserAgent(ssrUserAgent));
    const isMounted = useIsMounted();
    const bannerRef = useIntersectionRef(
        () => dispatchTrackingEvent(HOME_PAGE_VIEW_SPECIAL_OFFER_BANNER),
        { enabled: !IS_FRAME_SERVICE },
    );

    const handleTracking = () => {
        if (!IS_FRAME_SERVICE) {
            dispatchTrackingEvent(HOMEPAGE_SPECIAL_OFFER_BANNER);
        }
    };

    const ContainerElement = isMobile && isMounted ? Swiper : 'div';
    const swiperOptions = isMobile && isMounted ? {
        modules: [Autoplay, Pagination],
        loop: true,
        autoplay: { delay: 5000 },
        pagination: true,
        spaceBetween: 16,
    } : {};
    const ItemElement = isMobile && isMounted ? SwiperSlide : React.Fragment;
    // Bez ovoga ne izgleda dobro prije hidratacije na malim ekranima.
    const banners = !isMobile || isMounted ? data : [data[0]];

    return (
        <div ref={bannerRef}>
            <ContainerElement
                className="attractive-offer-banners"
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...swiperOptions}
            >
                {banners.map((banner, index) => (
                    <ItemElement key={index}>
                        <a
                            href={banner.hyperlink.redirectURL}
                            className={`attractive-offer-banners__item ${index === 1 ? 'attractive-offer-banners__item--second' : ''}`}
                            onClick={handleTracking}
                        >
                            <img loading="lazy" className="attractive-offer-banners__image" src={banner.image.sourceURL} alt={banner.image.altText} />
                            <svg className="attractive-offer-banners__background-line" xmlns="http://www.w3.org/2000/svg" width="847" height="240" viewBox="-122 0 847 240" fill="none">
                                <path d="M-122 238.027C-90.1667 186.361 24.1 79.6272 226.5 66.0272C479.5 49.0272 608 125.527 725 1.02722" stroke="#EBF8FE" strokeWidth="3" />
                            </svg>
                            <h3 className="attractive-offer-banners__title">
                                {banner.title}
                            </h3>
                            <span className="attractive-offer-banners__button">
                                <span className="attractive-offer-banners__button-text">
                                    {banner.hyperlink.redirectURLTitle}
                                </span>
                                <MdOutlineArrowForwardIos className="attractive-offer-banners__button-icon" />
                            </span>
                        </a>
                    </ItemElement>
                ))}
            </ContainerElement>
        </div>
    );
}
